module.exports = __webpack_public_path__ + "static/media/locatin.94ce6150.png";